import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-risk-index-badge',
    templateUrl: './risk-index-badge.component.html',
    styleUrls: ['./risk-index-badge.component.scss']
})
export class RiskBadgeComponent {
    @Input() riskLevel!: string;
    @Input() riskString!: string;
    @Input() hasDot: boolean = true;
    @Input() badgeClass?: 'High' | 'Medium' | 'Low' | 'NA' | 'Processing' | 'CodeSubmissions'
    @Input() hasFlag?: boolean = false;
    @Input() decimalPlaces: number = 2;
    @Input() originalityRiskFactorHighRisk: number;
    @Input() originalityRiskFactorMediumRisk: number;
    @Input() userInterfaceDisplay: string;
    @Input() processed?: number;
    @Input() isPublic?: boolean;
    @Input() checkPublicAccess?: boolean = false;

    flagIcon: string = '';
    displayRiskLevel: string = '';

    constructor(private translate: TranslateService) { }

    ngOnInit(): void {
        if (this.processed === 0 || this.processed === -1) {
            this.displayRiskLevel = this.translate.instant('new_entries.processing');
            return;
        }

        if (this.checkPublicAccess) {
            if (this.isPublic === false || this.isPublic === null) {
                this.displayRiskLevel = this.translate.instant('new_entries.access_pending');
                return;
            }
        } else {
            if (this.processed === 2) {
                this.displayRiskLevel = this.translate.instant('new_entries.suspended');
                return;
            }
        }

        const parsed = parseFloat(this.riskLevel);
        if (!isNaN(parsed)) {
            if (this.userInterfaceDisplay === 'riskFactor') {
                if (parsed >= this.originalityRiskFactorHighRisk) {
                    this.displayRiskLevel = this.translate.instant('new_entries.high_risk');
                } else if (parsed >= this.originalityRiskFactorMediumRisk) {
                    this.displayRiskLevel = this.translate.instant('new_entries.medium_risk');
                } else {
                    this.displayRiskLevel = this.translate.instant('new_entries.low_risk');
                }
            } else {
                this.displayRiskLevel = parsed.toFixed(this.decimalPlaces);
                if (parsed >= 100) {
                    this.displayRiskLevel = Math.round(parsed).toString();
                }
            }
        } else if (this.riskLevel && typeof this.riskLevel === 'string' && this.riskLevel.trim() !== '') {
            this.displayRiskLevel = this.riskLevel;
        } else {
            this.displayRiskLevel = this.decimalPlaces === 0 ? '0' : '0.' + '0'.repeat(this.decimalPlaces);
        }

        if (this.displayRiskLevel === 'NA') {
            this.displayRiskLevel = 'N/A';
        }
    }

    getFlagIconForRisk(risk: string): string {
        switch (risk?.toLowerCase()) {
            case 'high':
                return 'assets/images/icons/high_flag.png';
            case 'medium':
                return 'assets/images/icons/medium_flag.png';
            case 'low':
                return 'assets/images/icons/low_flag.png';
            default:
                return 'assets/images/icons/flag-default.png';
        }
    }
}


